import {action, computed, createTransformer, observable, runInAction, toJS} from 'mobx';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import unionBy from 'lodash/unionBy';
import moment from 'moment';
import request from '../../../utils/request';
import {MODULE, NOTIFICATION, PROJECT, PROJECT_ACTIVITIES, PROJECT_PUBLIC, STUDENT_ACTIVITIES, USER_PROJECT} from '../../../constants/urlConstants';
import {
    getId,
    getName,
    getNewLessonParams,
    getNewSenderData,
    getOwnerDetails,
    getUserAvatar,
    getUserMainInstrument,
    isAdmin,
    isGuest,
    isOwner,
    isSchoolAdmin,
    isSchoolUser,
    isStudent,
    isTeacher
} from '../../../utils/userUtility';
import looperStore from '../../create/looper/store';
import appStore from '../../app/store';
import mainStore from '../store';
import dialogStore from '../../dialog/store';
import manageStore from '../../../stores/ManageStore';
import groupStore from '../groups/store';
import notificationStore from '../../../stores/NotificationStore';
import notationViewerStore from '../../../stores/NotationViewerStore';
import {
    actions,
    AdminLessonsState,
    AlertType,
    AttachmentType,
    category,
    DialogTypes,
    events,
    labels,
    LessonNotificationType,
    LessonState,
    ModuleNotificationType,
    NotificationType,
    PlatformMode,
    ProjectNotificationType,
    ProjectStatus,
    ProjectType,
    SearchState,
    StudentLessonState,
    StudentStatus,
    StudioDrawerState,
    StudioMode,
    TrackActionType,
    TrackPlayStatus,
    UploadType
} from '../../../constants/enums';
import Player from '../../../stores/PlayerStore';
import {uploadToS3} from '../../../utils/awsUtility';
import {attachedTypeFile, capitalizeFirstLetter, checkFileExtension, guid} from '../../../utils/commonUtility';
import {convertToMp3, extractBuffer} from '../../../utils/audioUtility';
import actionStore from '../../../stores/ActionStore';
import searchStore from '../../../stores/SearchStore';
import uploadsProgressStore from '../../common/uploadsProgress/store'
import {
    ATTACHMENT_BUCKET,
    canvasTemplateUrl,
    MAX_HEIGHT_FOR_CANVAS_ZOOM,
    MIN_DISCOVERY_LESSON_ACCUMULATED_PLAYING_TIME,
    MULTIPLE_INSTRUMENTS,
    newTopic,
    NUM_ITEMS_PER_PAGE,
    PROJECT_SKILLS,
    RESTRICTED_BUCKET
} from '../../../constants/constants';
import {customEvent, lessonParamsForAnalytics} from '../../../utils/analyticsUtil';
import {go, goReplace, setProjectIdCreateUrl} from '../../../utils/navigationUtility';
import {isDesktop, isMobile} from '../../../utils/screenUtility';
import LessonDefaultImage from '../../../assets/images/bg-lesson.png';
import {isNumber, maxBy} from "lodash";
import flatten from 'lodash/flatten';
import Queue from "queue-promise";
import wizardStore from "../../studio/store";


const ONE_WEEK_IN_MILLISECONDS = 604800000;
const WHITEBOARD_COLLECTION_NAME = 'whiteboard';

class ProjectStore extends Player {
    @observable isProjectsLoaded = false;
    @observable isActivitiesLoaded = false;
    @observable isFetchingAllProjects = false;
    @observable isFetchingSingleProject = false;
    @observable isActivitiesFetching = false;
    @observable isProcessing = false;
    @observable searchFilter = '';
    @observable projectArray = [];
    @observable activities = [];
    @observable lessonActivities = [];
    @observable filteredStudentProjects = [];
    @observable filteredLessonPlans = [];
    @observable filteredAdminLessonLibrary = [];
    @observable randomDiscoveryLessonPlans = [];
    @observable groupedStudentProjects = [];
    @observable isLessonPlansLoading = false;
    @observable isLessonPlansLoaded = false;
    @observable isGroupedStudentProjectsLoaded = false;
    @observable isGroupedStudentProjectsLoading = false;
    @observable studentExistingLessons = [];
    @observable activeProjectID = null;
    @observable files = [];
    @observable notations = [];
    @observable videos = [];
    @observable videosLinks = [];
    @observable isFileLoading = false;
    @observable isLessonEditing = false;
    @observable isLessonBackgroundEditing = false;
    @observable editedLesson = null;
    @observable multiEditLessons = [];
    @observable isSavingBackground = false;
    @observable lessonState = LessonState.Create;
    @observable openedFile = {};
    @observable openedVideo = '';
    @observable pageCount = 1;
    @observable isActiveProjectPlaying = false;
    @observable lessonPlans = [];
    @observable isLoadingOnScroll = false;
    @observable isNewLessonFromLooper = false;
    @observable adminLessonFilterState = AdminLessonsState.All;
    @observable selectedLessonInLibrary = {};
    @observable showAssignmentIntro = true;
    @observable showAssignmentSummary = false;
    @observable onlyPublicLoaded = false;
    @observable isCanvasEditable = false;
    @observable autoStartCanvas = false;
    @observable isNotationCanvasEditable = false;
    @observable canvasRefs = [];
    @observable searchState = SearchState.lessonPlanLibrary;
    showFirstTopicNotes = false

    notificationsToLesson = [];

    promiseQueue = new Queue({
        concurrent: 1,
        interval: 1
    });

    constructor() {
        super();
        // this.promiseQueue.on("start", () => mainStore.toggleProgressLoader(true));
        this.promiseQueue.on("stop", async () => {
            console.log('sending notification')
            let studentId = this.activities.reduce((res, activity) => {
                if (!res) {
                    res = activity.studentId;
                }
                return res;
            }, null);
            if (studentId) {
                let notification = {
                    from: getId(),
                    receiverId: studentId,
                    objectType: NotificationType.Module,
                    type: ModuleNotificationType.EditModule,
                    objectId: studentId,
                    // objectName: module && module.topic && module.topic.text,
                    hide: true
                };
                await request(`${NOTIFICATION}`, {method: 'PUT', body: notification}, true);
            }
        });
    }

    @computed get enrichedProjects() {
        return this.projectArray;
    }

    @action setSearchState = (searchState) => {
        this.searchState = searchState;
    }

    @computed
    get lessonPlanList() {
        const filtered = isAdmin() ? this.filteredAdminLessonLibrary : this.myProjects;
        return this.filterProjectsBySearchStr(filtered, searchStore.getSearchStrFor(this.searchState));
    }

    @computed
    get sliceLessonPlanList() {
        return this.isProjectsLoaded ? this.lessonPlanList.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @computed
    get teacherLessons() {
        const userId = getId();
        return this.filterProjectsBySearchStr(this.enrichedProjects.filter((lesson) => {
            return (((lesson.owner.id === userId && isUndefined(lesson.assignedToAll) && lesson.status === ProjectStatus.Public) ||
                lesson.assignedToAll === true || !isEmpty(lesson.assignedUsers)));
        }).sort((a, b) => Date.parse(b.created) - Date.parse(a.created)), searchStore.getSearchStrFor(SearchState.teacherLessons));
    }

    @computed
    get sliceTeacherLessons() {
        return this.isProjectsLoaded ? this.teacherLessons.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    fixLessons = (lessons) => {
        if (!lessons) {
            return [];
        }
        return lessons.map((lesson) => {
            lesson.show = true;
            lesson.isShareable = lesson.isShareable === undefined ? true : lesson.isShareable;
            if (lesson.groupId) {
                lesson.groupName = groupStore.getGroupNameById(lesson.groupId);
                lesson.disableRemove = lesson.id === undefined;
            }
            if (lesson.userId !== getId()) {
                lesson.isNew = true;
            } else {
                if (lesson.auditLog) {
                    lesson.isNew = lesson.auditLog.findIndex(a => a.by === lesson.userId) === -1;
                } else {
                    lesson.isNew = parseInt(lesson.version, 10) === 0;
                }
            }
            return lesson;
        });
    }

    @computed
    get studentLessons() { // need for render lessons counter
        return this.enrichedProjects;
    }

    @computed
    get studentSearchedLessons() {
        const str = searchStore.getSearchStrFor(SearchState.studentLessons).toLowerCase();
        return JSON.parse(JSON.stringify(this.activities.filter(module => module.lessons?.length > 0 || module.topic?.text || module?.note || module.isTemp))).map(module => {
            module.lessons?.map(proj => {
                if (str) {
                    proj.show = (proj?.name.toLowerCase().includes(str) || (proj?.owner.name && proj.owner.name.toLowerCase().includes(str)));
                } else {
                    proj.show = true;
                }
            });
            if (str && module.lessons?.filter(lesson => lesson.show).length === 0) {
                return null;
            }
            return module;
        }).filter(module => !!module).sort((a, b) => b.order - a.order);
    }

    @computed
    get sliceStudentLessons() {
        return this.isProjectsLoaded ? this.studentSearchedLessons : [];
    }

    @computed
    get newLessonsCount() {
        return this.studentLessons.filter(lesson => lesson.isNew).length;
    }

    @computed
    get drafts() {
        const userId = getId();
        return this.filterProjectsBySearchStr(this.enrichedProjects.filter((project) => {
            return (project.owner.id === userId && isUndefined(project.parentProjectId) && isEmpty(project.assignedUsers) &&
                !isUndefined(project.assignedToAll) && project.assignedToAll === false);
        }).sort((a, b) => b.lastModified - a.lastModified), searchStore.getSearchStrFor(SearchState.drafts));
    }

    @computed
    get sliceDrafts() {
        return this.isProjectsLoaded ? this.drafts.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @computed
    get studentDrafts() {
        const userId = getId();
        return this.filterProjectsBySearchStr(this.myProjects.filter((project) => {
            return ((isUndefined(project.parentOwnerId) && project.owner.id === userId) || project.type === ProjectType.Project);
        }).sort((a, b) => b.lastModified - a.lastModified), searchStore.getSearchStrFor(SearchState.studentsProjects));
    }

    @computed
    get sliceStudentDrafts() {
        return this.isProjectsLoaded ? this.studentDrafts.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @computed
    get myProjects() {
        const userId = getId();
        let projects = this.enrichedProjects.slice().filter(p => (p.userId === userId || p.schoolShare) && !p.groupId);
        projects.sort((a, b) => {
                return b.lastModified - a.lastModified;
            }
        );
        return projects;
    }

    @computed
    get mySharedProjectsNum() {
        return this.myProjects.filter(p => p.schoolShare).length;
    }

    @computed
    get sharedProjects() {
        const projects = this.myProjects.filter(p => p.schoolShare && !p.sharedFolderId);
        return this.filterProjectsBySearchStr(projects, searchStore.getSearchStrFor(this.searchState));
    }

    @computed
    get allSharedProjects() {
        const projects = this.myProjects.filter(p => p.schoolShare);
        return this.filterProjectsBySearchStr(projects, searchStore.getSearchStrFor(this.searchState));
    }

    @computed
    get filteredAdminProjects() {
        const filteredBySearch = this.filterProjectsBySearchStr(this.myProjects, searchStore.getSearchStrFor(SearchState.teacherLessons))
        switch (this.adminLessonFilterState) {
            case AdminLessonsState.Published:
                return filteredBySearch.filter(p => p.isPublishTeachers || p.isPublishStudents);
            case AdminLessonsState.Unpublished:
                return filteredBySearch.filter(p => !p.isPublishTeachers && !p.isPublishStudents);
            default:
                return filteredBySearch;
        }
    }

    @computed
    get adminProjectsLabels() {
        return this.filteredAdminProjects.reduce((acc, p) => {
            if (!isEmpty(p.labels)) {
                acc = unionBy(acc, p.labels, 'value');
            }
            return acc;
        }, []);
    }

    @computed
    get filteredStudentActivities() {
        const str = searchStore.getSearchStrFor(SearchState.studentActivities).toLowerCase();
        let activities = this.activities.filter(module => module.lessons?.length > 0 || module.topic?.text || module?.note || module.isTemp);
        if (str) {
            // todo this is a workaround to toJS being too slow
            // but actually, this all method of returning the search results from the computed method, is even worse.
            activities = JSON.parse(JSON.stringify(this.activities)).map((module) => {
                module.lessons = module.lessons.filter(proj => {
                    return (proj?.name?.toLowerCase().includes(str) || (proj?.owner?.name && proj.owner?.name.toLowerCase().includes(str)));
                });
                if (module.lessons.length === 0) {
                    return null;
                }
                return module;
            }).filter(module => !!module)
        }
        return activities.sort((a, b) => b.order - a.order);
    }

    @computed
    get filteredLessonActivities() {
        return this.filterProjectsBySearchStr(this.activities, searchStore.getSearchStrFor(SearchState.lessonActivities));
    }

    @computed
    get activeProject() {
        if (!isEmpty(this.activeProjectID)) {
            return this.enrichedProjects.find(project => project.id === this.activeProjectID);
        }
        return null;
    }

    @computed
    get collectionProjects() {
        const groups = this.filteredLessonPlans.reduce((acc, p) => {
            if (!isEmpty(p.labels)) acc = unionBy(acc, p.labels, 'value');
            return acc;
        }, []).map(l => ({
            isCollection: true,
            id: l.value,
            title: l.label,
            projects: []
        }));

        let index = 0;
        return this.filteredLessonPlans.reduce((acc, p) => {
            if (!isEmpty(p.labels)) {
                p.labels.forEach(l => {
                    const group = groups.find(g => g.id === l.value);
                    group.projects.push(p);
                    if (!acc.some(i => i.id === group.id)) {
                        acc.splice(index, 0, group);
                        index++
                    }
                })
            } else acc.push(p);
            return acc;
        }, []);

    }

    @computed
    get filteredByNameLessonPlans() {
        return this.filteredLessonPlans
            .filter(lesson => (lesson.labels || []).map(label => label.value).findIndex(label => label === WHITEBOARD_COLLECTION_NAME) === -1)
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }

    @computed
    get filteredByNameCollectionProjects() {
        return this.collectionProjects.filter(collection => !collection.isCollection || collection.id !== WHITEBOARD_COLLECTION_NAME).map(collection => {
            collection.projects = collection.projects && collection.projects.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

            return collection;
        })
    }

    @computed
    get filteredOnlyCollections() {
        return this.filteredByNameCollectionProjects.filter(collection => collection.isCollection)
    }


    @computed
    get sliceFilteredLessonPlans() {
        return this.isLessonPlansLoaded ? this.filteredByNameLessonPlans.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @computed
    get introLessonPlans() {
        return this.isLessonPlansLoaded ? this.lessonPlans.filter((lessons) => lessons.includeInDemoStudent).slice(0, 3) : [];
    }

    @computed
    get whiteboardCollection() {
        return this.isLessonPlansLoaded ? this.collectionProjects
            .filter((collection) => collection.isCollection && collection.id === WHITEBOARD_COLLECTION_NAME)
            .map(collection => collection.projects).flat() || []
            : [];
    }

    @computed
    get sliceCollectionProjects() {
        return this.isLessonPlansLoaded ? this.filteredByNameCollectionProjects.slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    /**
     * get all available projects filtered
     * @returns {Array}
     */
    @computed
    get filteredProjects() {
        return isTeacher() ? this.getFilteredStudentsExistingsLessons() : this.getUserFilteredExistingsLessons();
    }

    @computed
    get videoUrls() {
        return toJS(this.videosLinks);
    }

    @computed
    get attachmentFiles() {
        return this.files;
    }

    @computed
    get notationFiles() {
        return this.notations;
    }

    @computed
    get filteredProjectsByParentId() {
        return this.myProjects.filter(p => p.parentProjectId === this.activeProjectID);
    }

    @computed
    get totalPracticeTimeInSeconds() {
        return this.getPracticeTime(this.activities);
    }

    @computed
    get lastWeekPracticeTimeInSeconds() {
        return this.getPracticeTime(this.activities, ONE_WEEK_IN_MILLISECONDS);
    }

    @computed
    get accumulatedSkills() {
        const modules = this.activities;
        let accumulatedObj = {};
        PROJECT_SKILLS.forEach(s => {
            accumulatedObj[s.type] = 0;
        })
        modules.forEach(module => {
            module?.lessons?.forEach(proj => {
                if (proj.skills && proj.practiceTime && proj.practiceTime.length > 0) {
                    proj.skills.forEach(skill => {
                        accumulatedObj[skill.type] = accumulatedObj[skill.type] ? accumulatedObj[skill.type] + 1 : 1;
                    });
                }
            })
        });
        let result = [];
        Object.keys(accumulatedObj).forEach(key => {
            result.push({
                type: key,
                value: accumulatedObj[key]
            });
        });
        result.sort((a, b) => {
            return b.value - a.value
        });
        return result;
    }

    getPracticeTime = (modules, diffInMilliseconds) => {
        let count = 0;
        let now = Date.now();
        let tmpArray;
        modules.forEach(module => {
            module?.lessons?.forEach(project => {
                if (project.practiceTime) {
                    tmpArray = diffInMilliseconds ? project.practiceTime.filter(obj => {
                        return now - obj.startDate < diffInMilliseconds
                    }) : project.practiceTime;
                    count += tmpArray.reduce((a, b) => a + b.durationInSeconds, 0);
                }
            });
        });
        return count;
    }

    getFilteredStudentsExistingsLessons = () => {
        return this.studentExistingLessons.filter(l => `${l.name} ${l.student.name}`.toLocaleLowerCase().includes(this.searchFilter.toLowerCase()));
    };

    getUserFilteredExistingsLessons() {
        return this.enrichedProjects.filter((project) => {
            const fields = project.contributors.reduce((acc, curr) => {
                return `${acc} ${curr.name}`;
            }, '');
            return !!project.parentProjectId && project.name.concat(fields).toLowerCase().includes(this.searchFilter.toLowerCase());
        }).sort((a, b) => a.lastModified < b.lastModified);
    }

    /**
     * Set the active project
     * @param projectID   {String}    The project id to set as active
     */
    @action
    setActiveProject = async (projectID) => {
        await this.fetchProject(projectID);
        runInAction(() => {
            this.activeProjectID = projectID;
        });
    };

    @action
    setIsNewLessonFromLooper = (flag) => {
        this.isNewLessonFromLooper = flag;
    };

    filterProjectsBySearchStr = (projects, searchStr = '') => {
        const str = searchStr.toLowerCase();
        return projects.filter((proj) => {
            return (proj.name.toLowerCase().includes(str) || (proj.owner.name && proj.owner.name.toLowerCase().includes(str)));
        });
    };

    @action
    getDrafts = async () => {
        await this.fetchProjects();
    };

    @action
    getStudentDrafts = async () => {
        await this.fetchProjects();
    };

    @action
    fetchStudentActivities = async (searchStr, student) => {
        this.isActivitiesFetching = true;
        this.isActivitiesLoaded = false;
        try {
            await this.fetchProjects();
            let {modules} = await request(`${STUDENT_ACTIVITIES}/${student.id}`);
            modules.forEach((module, index, collection) => {
                if (index + 1 < collection.length) {
                    module.next = collection[index + 1].id;
                }
                if (index - 1 >= 0) {
                    module.prev = collection[index - 1].id;
                }

                module.lessons = this.fixLessons(module.lessons);
                module.note = module.note || '';
                module.topic = module.topic || {};
                module.editMode = false;
            });
            modules.sort((a, b) => {
                return b.order - a.order;
            });
            runInAction(() => {
                this.activities = modules;
                this.isActivitiesLoaded = true;
            });
        } catch (err) {
            console.log(err);
        } finally {
            runInAction(() => {
                this.isActivitiesFetching = false;
            });
        }
    };

    createStudentAllActivitiesList = (lessons, activities, student) => {
        const result = activities.slice();
        lessons.forEach((lesson) => {
            if (lesson.userId !== student.id && lesson.userId !== getId() && !isSchoolUser()) {
                return;
            }
            if (result.findIndex(activity => activity.parentProjectId === lesson.id) === -1) {
                let isStudentsGroupLesson = false;
                if (lesson.groupId) {
                    const groupStudents = groupStore.getGroupStudents(lesson.groupId);
                    isStudentsGroupLesson = groupStudents.findIndex(user => user.id === student.id) !== -1;
                }
                if (lesson.userId !== student.id && (isStudentsGroupLesson || isUndefined(lesson.assignedToAll) || lesson.assignedToAll
                    // || (lesson.assignedUsers && lesson.assignedUsers.findIndex(user => user.id === student.id) !== -1)
                ) && this.validateUserIdIsMeOrTeacher(lesson.userId)) {
                    result.push(this.createStudentPendingLessonObject(lesson, student));
                }
            }
        });
        return result;
    };

    validateUserIdIsMeOrTeacher = (userId) => {
        return userId === getId() || manageStore.teachers?.some(teacher => userId === teacher.id);
    }


    createStudentPendingLessonObject = (lesson, student) => {
        const {avatar, id, name} = student;
        const groupId = lesson.groupId;
        let assignedDate = lesson.updated;
        if (!lesson.assignedToAll && lesson.assignedUsers && lesson.assignedUsers.length > 0) {
            let assignedUserObj = lesson.assignedUsers.filter(user => user.id === id);
            if (assignedUserObj && assignedUserObj.assignedDate) {
                assignedDate = assignedUserObj.assignedDate;
            }
        }
        return {
            created: assignedDate,
            name: lesson.name,
            owner: {
                avatar,
                id,
                name
            },
            parentOwnerId: lesson.parentOwnerId,
            userId: lesson.userId,
            state: StudentLessonState.Pending,
            parentProjectId: lesson.id,
            backgroundImg: lesson.backgroundImg,
            disableRemove: isUndefined(lesson.assignedToAll) || lesson.assignedToAll,
            groupId: groupId
        }
    };

    @computed get searchLessonActivities() {
        const str = searchStore.getSearchStrFor(SearchState.studentActivities).toLowerCase();
        return this.lessonActivities.filter(lessonActivity => lessonActivity?.owner?.name?.toLowerCase().includes(str));
    }

    @action fetchLessonActivities = async (searchStr, lessonId) => {
        this.isActivitiesFetching = true;
        try {
            const lessonPromise = projectStore.fetchProject(lessonId);
            const activitiesPromise = request(PROJECT_ACTIVITIES(lessonId));
            const [lesson, activities] = await Promise.all([lessonPromise, activitiesPromise]);
            activities.forEach(a => console.log(a.owner.name))

            const allActivities = this.createLessonAllActivitiesList(lesson, activities);
            allActivities.sort((a, b) => moment(b.created).diff(moment(a.created)));
            runInAction(() => {
                this.lessonActivities = allActivities;
            });
        } catch (e) {
            console.log(e);
            return [];
        } finally {
            runInAction(() => {
                this.isActivitiesFetching = false;
            });
        }
    };

    createLessonAllActivitiesList = (lesson, activities) => {
        const demoStudentId = manageStore.demoStudentId;
        const allActivities = activities.slice();
        let assignedUsers = [];
        if (lesson.groupId) {
            assignedUsers = groupStore.getGroupStudents(lesson.groupId);
        } else if (lesson.assignedUsers) {
            assignedUsers = lesson.assignedUsers;
        }
        console.log(assignedUsers.length);
        assignedUsers.forEach((user) => {
            if (allActivities.findIndex(les => les.owner.id === user.id) === -1) {
                allActivities.push(this.createStudentPendingLessonObject(lesson, user));
            }
        });
        return allActivities.filter(activity => activity.owner.id !== demoStudentId);
    };

    @action
    getStudentsActivities = async (force = false) => {
        if ((isTeacher() || isSchoolAdmin()) && (!this.isGroupedStudentProjectsLoading) && (!this.isGroupedStudentProjectsLoaded || force)) {
            this.isGroupedStudentProjectsLoading = true;
            const projects = await request('project/students/activities');
            runInAction(() => {
                this.groupedStudentProjects = projects;
                this.isGroupedStudentProjectsLoading = false;
                this.isGroupedStudentProjectsLoaded = true;
                this.studentExistingLessons = this.getStudentExistingLessons(projects);
            });
        }
    };

    getStudentExistingLessons(projects) {
        const result = [];
        projects.forEach(({id, name, students}) => {
            const projectDetail = this.getProject(id) || {};
            students.forEach((student) => {
                if (student.projectId) {
                    result.push({id, name, serialNum: projectDetail.serialNum, student});
                }
            });
        });
        return result;
    }

    @action getPublicLessonPlans = async (searchStr, filters) => {
        return await this.getLessonPlansHelper(searchStr, filters, true);
    };

    @action getLessonPlans = async (searchStr, filters) => {
        return await this.getLessonPlansHelper(searchStr, filters, false);
    };

    @action getLibraryLessons = async (searchStr, filters) => {
        await this.fetchProjects();
        runInAction(() => {
            this.filteredAdminLessonLibrary = this.getFilteredLessonPlans(searchStr.toLowerCase(), filters);
        });
        return await this.getLessonPlansHelper(searchStr, filters, false);
    };

    getLessonPlansHelper = async (searchStr, filters, isPublic) => {
        if ((!this.isLessonPlansLoaded && !this.isLessonPlansLoading) || (!isPublic && this.onlyPublicLoaded)) {
            this.isLessonPlansLoading = true;
            try {
                if (!isPublic) {
                    await this.fetchProjects();
                }
                let publicRequest = `public/${PROJECT}/global`;
                let cachedRequest = `public/v2/${PROJECT}/global`;
                const response = await request(isPublic ? publicRequest : cachedRequest);
                response.forEach((lessonPlan) => {
                    const lessonCategory = lessonPlan.category ? lessonPlan.category : '';
                    const lessonLevel = lessonPlan.level ? lessonPlan.level : '';
                    const lessonKey = lessonPlan.musicalKey ? lessonPlan.musicalKey : '';
                    const lessonInstruments = lessonPlan.instruments ? lessonPlan.instruments.map(l => l.name || l).join(' ') : '';
                    lessonPlan.paramsString = `${lessonPlan.name} ${lessonCategory} ${lessonLevel} ${lessonKey} ${lessonInstruments} ${lessonPlan.artistName || ''} ${lessonPlan.owner.name || ''} ${lessonPlan.keywords || ''}`.toLowerCase().trim();
                });
                response.sort((a, b) => {
                    return a.updated > b.updated ? -1 : 1;
                });
                runInAction(() => {
                    this.onlyPublicLoaded = isPublic;
                    this.lessonPlans.replace(response.map(proj => this.initTrack(proj)));
                    this.filteredLessonPlans = this.getFilteredLessonPlans(searchStr ? searchStr.toLowerCase() : '', filters);
                    this.isLessonPlansLoaded = true;
                    this.randomDiscoveryLessonPlans = this.getRandomDiscoveryLessonPlans(4);
                });
            } catch (err) {
                console.log(err);
            } finally {
                runInAction(() => {
                    this.isLessonPlansLoading = false;
                });
            }
        } else {
            runInAction(() => {
                if (isPublic && this.lessonPlans) {
                    this.lessonPlans.replace(this.lessonPlans.filter(p => p.keywords && p.keywords.includes('public')));
                }
                this.filteredLessonPlans = this.getFilteredLessonPlans(searchStr ? searchStr.toLowerCase() : '', filters);
            });
        }
    };

    getFilteredLessonPlans = (searchStr, filters) => {
        const {instrument, category, level, musicalKey, sortBy, skill, label} = filters;
        const plans = isAdmin() ? this.myProjects : this.lessonPlans;
        let result = plans.filter(lessonPlan => {
                return ((!category || this.getMultipleFilterCheck(lessonPlan.category, category) || category.isAll) &&
                    (!level || this.getMultipleFilterCheck(lessonPlan.level, level) || level.isAll) &&
                    (!musicalKey || this.getMultipleFilterCheck(lessonPlan.musicalKey, musicalKey) || musicalKey.isAll) &&
                    (!skill || (lessonPlan.skills && lessonPlan.skills.find(i => this.getMultipleFilterCheck(i.type, skill))) || skill.isAll) &&
                    (!instrument || (lessonPlan.instruments && lessonPlan.instruments.find(i => this.getMultipleFilterCheck(i.name || i, instrument) || (i.name || i) === MULTIPLE_INSTRUMENTS)) || instrument.isAll) &&
                    (!label || (lessonPlan.labels && lessonPlan.labels.some(l => l.label === label))) &&
                    (isUndefined(lessonPlan.paramsString) || lessonPlan.paramsString.includes(searchStr) || lessonPlan.keywords?.includes(searchStr)))
            }
        );
        if (sortBy) {
            result = sortBy.action(result);
        }
        return result;
    };

    getMultipleFilterCheck = (lessonProp, filter) => {
        if (!filter?.length) {
            return lessonProp === filter.value;
        }
        return filter.some(item => item.value === lessonProp)
    }

    getLessonPlansInstruments = () => {
        let instruments = [];
        const plans = isAdmin() ? this.myProjects : this.lessonPlans;
        plans.forEach(plan => {
            if (plan.instruments) {
                plan.instruments.forEach(planInstrument => {
                    if (instruments.findIndex(instrument => instrument.name === planInstrument.name) === -1) {
                        instruments.push(planInstrument);
                    }
                });
            }
        });
        return instruments;
    }


    @action
    getGroupedStudentProjects = async (searchStr) => {
        const promises = [];
        promises.push(this.fetchProjects());
        if (!this.isGroupedStudentProjectsLoaded) {
            promises.push(this.getStudentsActivities());
        }
        if (promises.length > 0) {
            await Promise.all(promises);
        }

        runInAction(() => {
            this.filteredStudentProjects = this.groupedStudentProjects.filter((project) => {
                const fields = project.students.reduce((acc, curr) => {
                    return `${acc} ${curr.name}`;
                }, '');
                return project.name.concat(fields).toLowerCase().includes(searchStr || '');
            });
        });
    };

    getNumLessonsInLibrary = async () => {
        await this.getTeacherLessons();
        return this.teacherLessons.length;
    };

    @action
    getLessonPlanLibrary = async (searchStr, filters) => {
        await this.fetchProjects();
        runInAction(() => {
            this.filteredAdminLessonLibrary = this.getFilteredLessonPlans(searchStr.toLowerCase(), filters);
        });
    };

    @action
    getTeacherLessons = async () => {
        await this.fetchProjects();
    };

    @action getStudentLessons = async () => {
        await this.fetchProjects();
    };

    @action addStudentLessons = (lesson) => {
        this.myProjects.unshift(lesson);
        const parentProjectIndex = this.myProjects.findIndex(p => p.id === lesson.parentProjectId);
        this.myProjects.splice(parentProjectIndex, 1);
    };

    @action duplicateLesson = async (lesson, isShowSuccessDialog = true) => {
        mainStore.toggleProgressLoader(true);
        try {
            const resp = await request(`${PROJECT}/${lesson.id}/duplicate`, {method: 'POST', body: {}});
            runInAction(() => {
                if (lesson.userId === getId()) {
                    this.projectArray.unshift(this._processProject(resp));
                } else {
                    resp.lessons = this.fixLessons(resp.lessons);
                    this.activities.push(resp);
                }
                mainStore.toggleProgressLoader(false);
                if (isShowSuccessDialog) {
                    appStore.createAlertFromMessageId(AlertType.Success, 'library.lessons.duplicateSuccess.toast');
                    // dialogStore.openDialog(DialogTypes.DuplicateProjectSuccess);
                }
            });
            return resp;
        } catch (error) {
            appStore.createAlertFromMessageId(AlertType.Error, 'notifications.error');
            mainStore.toggleProgressLoader(false);
        }
    };


    adminCopyLessons = async (targetTeacherEmail, lessonsStr, targetFolderName, targetShare) => {
        let lessons = lessonsStr.split('\n').filter(x => !!x).map(x => x.trim());
        return await request(`${PROJECT}/clone/global`, {method: 'POST', body: {projects: lessons, targetTeacherEmail, targetFolderName, targetShare}});
    }


    /**
     * Update Project field
     * @param projectID {String}    The project id to update
     * @param field {String}    The track field to update
     * @param value    {*}   The new value to set into the project field
     */
    @action updateField = (projectID, field, value) => {
        const selectedProject = this.enrichedProjects.find(p => p.id === projectID);
        if (!isEmpty(selectedProject)) {
            selectedProject[field] = value;
            if (field !== 'version') {
                selectedProject.version += 1;
            }
        }
    };

    /**
     * Set the project drawer list searchFilter
     * @param value {string}    the project searchFilter
     */
    @action setSearchFilter = (value) => {
        this.searchFilter = value;
    };

    @action
    async fetchProjects() {
        if (!this.isProjectsLoaded) {
            if (!this.isFetchingAllProjects) {
                this.isFetchingAllProjects = true;
                try {
                    //const projects = await request(`${PROJECT}/new`);
                    const {modules, projects} = await request(`${PROJECT}`);
                    runInAction(() => {
                        if (isStudent()) {
                            this.activities = modules.map(module => {
                                module.lessons = this.fixLessons(this.processProjectData(module.lessons))
                                return module;
                            }).sort((a, b) => b.order - a.order);
                            this.projectArray = (flatten(this.activities.map(module => module.lessons.slice())) || []).concat(projects);
                        } else {
                            this.projectArray = this.processProjectData(projects);
                        }

                        this.isProjectsLoaded = true;
                    });
                } catch (err) { // do nothing
                    console.log('error fetching project:', err);
                } finally {
                    runInAction(() => {
                        this.isFetchingAllProjects = false;
                    });
                }
            } else {
                let interval;
                return new Promise((resolve) => {
                    clearInterval(interval);
                    interval = setInterval(() => {
                        if (!this.isFetchingAllProjects) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 100);
                });
            }
        }
    }

    /**
     * Process the project data to present in UI
     * @param projects  {Array} The user project array
     */
    processProjectData = (projects) => {
        return projects.reduce((projectList, project) => {
            projectList.push(this._processProject(project));
            return projectList;
        }, []);
    };

    _processProject = (project) => {
        if (isNumber(project.order)) {
            return project;
        }
        project.chat = project.chat ? project.chat : [];
        project.show = true
        project.contributors = project.contributors ? project.contributors : [];
        project.bpm = project.bpm || (project.loopers && project.loopers[0] && project.loopers[0].bpm);
        project.pitch = project.pitch || 0;
        project.lastModified = Date.parse(project.updated);
        project.contributors = project.contributors.reduce((contributors, contributor) => {
            if (!isOwner(contributor.id)) {
                contributors.push(contributor);
            }
            return contributors;
        }, []);
        project.isShareable = project.isShareable === undefined ? true : project.isShareable;
        return project;
    };

    _createActivity = (lesson) => {
        return {
            created: lesson.created,
            id: lesson.id,
            name: lesson.name,
            owner: lesson.owner,
            state: StudentLessonState.Active,
            hasParent: lesson.parentProjectId !== undefined,
            parentProjectId: lesson.parentProjectId,
            backgroundImg: lesson.backgroundImg
        }
    };

    /**
     * Fetch project by id
     * @param projectId {String}    The project to fetch
     * @param force {boolean}   Indicator whether or not to fetch the project even if exists
     * @returns {Promise.<void>}
     */
    @action
    async fetchProject(projectId, force = false, ignoreError = false) {
        try {
            this.isFetchingSingleProject = true;
            const reqProjectIndex = this.projectArray.findIndex(project => project.id === projectId);
            if (!force && reqProjectIndex > -1) {
                const project = this.projectArray[reqProjectIndex];
                if (!isUndefined(project.loopers)) {
                    this.selectedLessonInLibrary = project;
                    return project;
                }
            }
            const project = await request(`${!!getId() ? PROJECT : PROJECT_PUBLIC}/${projectId}`, {}, ignoreError);
            runInAction(() => {
                if (reqProjectIndex > -1) {
                    this.projectArray.splice(reqProjectIndex, 1);
                }
                if (!isEmpty(project)) {
                    this.projectArray.unshift(this._processProject(this.initTrack(project)));
                }
                this.selectedLessonInLibrary = project;
            });
            return project;
        } finally {
            runInAction(() => {
                this.isFetchingSingleProject = false;
            });
        }
    }

    @action
    async loadLesson(projectId, sendNotification = false) {
        const project = await this.fetchProject(projectId, false);
        const isUserProjectOwner = project.owner.id === getId();
        setTimeout(async () => {
            mainStore.finishStemsAnimation(!project.loopers.length);
            await looperStore.addProjectToLooper(project);

            // if (project.userId && getId() && project.userId !== getId()) {
            //     mainStore.openMainAppDrawer();
            //     mainStore.setStudioDrawerState(StudioDrawerState.Info);
            // }
        }, 0);
        await this.setActiveProject(project.id);
        if (sendNotification && project.parentProjectId && isUserProjectOwner && project.type !== ProjectType.Project) {
            const notification = {
                receiverId: project.parentOwnerId, objectId: project.id,
                objectName: project.name, parentProjectId: project.parentProjectId,
                objectType: NotificationType.Lesson, type: LessonNotificationType.OpenLesson,
                hide: true,
                merge: false
            };
            request(`${NOTIFICATION}`, {method: 'PUT', body: notification});
        }
        return project;
    }

    /**
     * Send notification that project has been renamed
     * @param object   {Object}    The  object to notify for
     * @param extraData  {Object}    Extra data to pass
     * @param notificationType  {String}    Project notification type according to enum
     */
    notifyProject = (object, notificationType, extraData = {}) => {
        if (object.status !== ProjectStatus.PrivateOwner) {
            try {
                request(`${NOTIFICATION}/${PROJECT}/${object.id}`, {
                    method: 'POST',
                    body: {
                        ...getNewSenderData(),
                        objectId: object.id,
                        objectType: NotificationType.Project,
                        type: notificationType,
                        message: object.name,
                        ...extraData
                    }
                });
            } catch (err) {
                throw err;
            }
        }
    };

    _serializeLoop = (loopData) => {
        const {
            bpm,
            fileId,
            fileType,
            id,
            name,
            originalDuration,
            duration,
            originalBPM,
            owner,
            trackActionData,
            trackId,
            userId,
            volume,
            instruments,
            color,
            backgroundImage,
            mark,
            ctaDescription = null,
            index = null,
            attachments = [],
            latencyFixed = false,
            uploadType = UploadType.UploadFile,
            originalPitch = 0
        } = loopData;
        if (id) {
            return {
                color,
                bpm,
                fileId,
                fileType,
                id,
                mark,
                name,
                originalBPM,
                owner,
                trackActionData,
                trackId,
                userId,
                volume,
                originalDuration,
                duration,
                backgroundImage,
                instruments: instruments ? instruments.slice() : [],
                ctaDescription,
                index,
                attachments,
                latencyFixed,
                uploadType,
                originalPitch
            };
        }
        return {
            color,
            ctaDescription,
            index
        };
    };

    /**
     * Remove temporary looper details
     * @param loopers
     * @private
     */
    _processLoopers = (loopers) => {
        if (!loopers || !loopers.length) {
            return [];
        }
        return loopers.reduce((looperTracks, track) => {
            looperTracks.push(this._serializeLoop(track));
            return looperTracks;
        }, []);
    };

    _serializeProject = (projectData, project) => {
        projectData = Object.assign({}, project, projectData);
        const bpm = project.bpm || (!isEmpty(projectData.loopers) && projectData.loopers[0].bpm);
        if (bpm) {
            projectData.bpm = bpm;
        } else {
            delete projectData.bpm;
        }
        return projectData;
    };


    async saveProjectTrack(projectData) {
        try {
            const output = await this.getAudioBufferForTracks(looperStore.looperTracks);
            const metaData = {peaks: extractBuffer(output), buffer: output, duration: output.duration};
            const fileData = await convertToMp3(output);
            projectData.duration = metaData.duration;
            projectData.peaks = metaData.peaks;
            projectData.fileId = projectData.fileId || guid();

            await uploadToS3(fileData, `audio/${projectData.fileId}`, 'audio/mp3', null, RESTRICTED_BUCKET, true);
        } catch (err) {
            console.log(err);
        }
    }

    isRelevantXml = (file = {}) => {
        const type = attachedTypeFile(file);
        const userInstrument = (getUserMainInstrument() || '').toLowerCase();
        const matchInstrumentInFileName = (file.name || '').toLowerCase().includes(userInstrument);
        return (type === AttachmentType.Xml) && matchInstrumentInFileName;
    };

    @action saveMultiProject = async (updateData) => {
        try {
            this.isProcessing = true;
            const resp = await request(`${PROJECT}/multi-edit`, {method: 'POST', body: {updateData, lessons: this.multiEditLessons}});
        } catch (err) {
            console.log(err);
            // rethrow
            throw err;
        } finally {
            runInAction(() => {
                this.isProcessing = false;
            })
        }
    }

    /**
     * Save the project - performs create or update for a project
     * @param projectName {String} The new project name
     * @param project {Object}    The project in case of update
     * @param isAddToLooper {Boolean} Upload to looper after create project
     * @param isResetSearch {Boolean} Search reset
     * @returns {Promise.<void>}
     */
    @action
    async saveProject(projectName, project, isAddToLooper = false, useProjectLoopers = true, isResetSearch = true, showAnalytics = true) {
        const loopers = this._processLoopers(useProjectLoopers ? project.loopers : looperStore.allTracks);
        let projectData = {
            ...project,
            name: projectName,
            loopers: loopers,
            actions: project.actions,
            masterVolume: looperStore.masterVolume,
            attachments: project.attachments || [],
            notations: project.notations || [],
            videoUrls: project.videoUrls || []
        };
        this.isProcessing = true;
        mainStore.toggleProgressLoader(true);
        if (showAnalytics) {
            this.showSaveAnalytics(project);
        }
        if (this.files.length) projectData.attachments = [...this.files];
        if (this.notations.length) projectData.notations = [...this.notations];
        if (this.videos.length) projectData.videoUrls = [...this.videos];
        let isNewProject = false;
        if (project.id) {
            projectData = this._serializeProject(projectData, project);
        } else {
            isNewProject = true;
            if (!project.owner) {
                projectData.owner = {
                    id: getId(),
                    name: getName(),
                    avatar: getUserAvatar()
                };
            }
        }
        actionStore.init();
        if (!isEmpty(project.actions)) {
            actionStore.setMinUndoLength(project.actions.length);
            project.actions.forEach(curAction => actionStore.add(curAction));
        }
        actionStore.setIsDirty(false);
        try {
            await looperStore.saveNewStemsAsTracks();
            // todo we need to move this in the share flow (this will be done later)
            // if (loopers.length) await this.saveProjectTrack(projectData);
            const resp = await request(`${PROJECT}`, {method: 'POST', body: projectData});
            delete resp.loopers;
            return await runInAction(async () => {
                let savedProject;
                const selectedProject = this.projectArray.find(p => p.id === project.id);
                if (!isEmpty(selectedProject)) {
                    Object.assign(selectedProject, this._processProject({
                        ...projectData,
                        ...resp,
                        playerID: null
                    }));
                    savedProject = toJS(selectedProject);
                    if (savedProject.name !== projectName) {
                        this.notifyProject(savedProject, ProjectNotificationType.Rename, {objectName: projectName});
                    }
                } else {
                    savedProject = this._processProject(Object.assign({}, projectData, resp));
                    this.setFileInput(savedProject)
                    if (resp.userId === getId()) {
                        this.projectArray.push(savedProject);
                    } else {
                        if (resp.parentProjectId) {
                            await this.fetchProject(resp.parentProjectId, true);
                        }
                    }
                }
                const containingModule = this.getModuleByLessonId(savedProject.id)
                const index = containingModule?.lessons.findIndex((l) => l.id === savedProject.id)
                if (index >= 0) {
                    containingModule.lessons[index] = savedProject
                }
                if (isAddToLooper) {
                    await looperStore.addProjectToLooper({...savedProject, name: resp.name});
                } else {
                    looperStore.setLoopedProject(savedProject);
                }
                if (parseInt(savedProject.version, 10)) {
                    // this.notifyProject(savedProject, ProjectNotificationType.Save);
                } else {
                    await this.setActiveProject(savedProject.id);
                }
                if (savedProject.parentOwnerId && isStudent()) {
                    let hide = false;
                    let lessonEditTypes = this.notificationsToLesson;
                    if (isNewProject && lessonEditTypes.length === 0) {
                        lessonEditTypes.push(LessonNotificationType.OpenLessonFirst);
                        hide = true;
                    } else if (lessonEditTypes.length === 0) {
                        lessonEditTypes.push(LessonNotificationType.EditLesson)
                        hide = true;
                    }

                    lessonEditTypes.map(lessonEditType => {
                        const notification = {
                            receiverId: isStudent() ? savedProject.parentOwnerId : savedProject.owner.id,
                            objectId: savedProject.id,
                            objectName: savedProject.name,
                            parentProjectId: savedProject.parentProjectId,
                            objectType: NotificationType.Lesson,
                            hide: hide,
                            merge: false,
                            type: lessonEditType
                        };
                        request(`${NOTIFICATION}`, {method: 'PUT', body: notification});
                    })
                    this.notificationsToLesson = [];
                }
                if (isNewProject) {
                    setProjectIdCreateUrl(savedProject.id);
                    this.showFirstTopicNotes = true;
                    // if (savedProject.userId !== getId()) {
                    //     await this.createNewModule(savedProject, savedProject.userId);
                    // }
                    await notificationStore.subscribeToProject(savedProject.id);
                }
                runInAction(() => {
                    this.selectedLessonInLibrary = savedProject;
                });
                return savedProject;
            });
        } catch (err) {
            throw err;
        } finally {
            runInAction(() => {
                this.isProcessing = false;
                mainStore.toggleProgressLoader(false);
                if (isResetSearch) searchStore.reset();
            });
        }
    }

    showSaveAnalytics = (project) => {
        if (project.id) {
            return customEvent(events.CustomEvent, {
                category: category.SaveChanges,
                action: project?.userId !== getId() || project?.groupId ? actions.Assignment : actions.Lesson
            });
        }
        if (project.musicoLesson) {
            if (!project.groupId && project.userId === getId()) {
                return customEvent(events.CustomEvent, {
                    category: category.SaveMusicoLesson,
                    action: actions.FromStudio,
                    label: lessonParamsForAnalytics(project)
                });
            }
            return customEvent(events.CustomEvent, {
                category: project.groupId ? category.AssignGroupLesson : category.AssignLesson,
                action: actions.FromStudio,
                ...lessonParamsForAnalytics(project)
            });
        }
        if (project.saved) {
            return customEvent(events.CustomEvent, {
                category: project.groupId ? category.AssignGroupLesson : category.AssignLesson,
                action: actions.FromStudio
            })
        }
        return customEvent(events.CustomEvent,
            project?.userId !== getId() || project?.groupId ?
                {category: project.groupId ? category.AssignGroupLesson : category.AssignLesson, action: actions.FromStudio, label: labels.New}
                : {category: category.SaveLesson, action: actions.New})
    }

    /**
     * Save/Update project and update the loopedProject
     * @returns {Promise<void>}
     */
    @action
    handleProjectSave = async (saveMasterTrack = false, showSuccessMessage = true) => {
        const type = isTeacher() || isSchoolAdmin() ? ProjectType.Lesson : ProjectType.Project;
        const project = {...looperStore.loopedProject};
        this.setFileInput(project);
        project.status = project.status || ProjectStatus.Private;
        project.type = isUndefined(project.type) ? type : project.type;
        try {
            project.actions = actionStore.getAll();
            if (!isEmpty(project.actions) && project.actions[project.actions.length - 1].type === TrackActionType.Copy) {
                project.actions = project.actions.slice(0, project.actions.length - 1);
            }
            if (saveMasterTrack && project.type === ProjectType.Global && looperStore.looperTracks.length > 0 && looperStore.looperTracks[0].playerID) {
                this.isProcessing = true;
                mainStore.toggleProgressLoader(true);
                await this.saveProjectTrack(project);
            }
            await this.saveProject(looperStore.looperProjectName || 'Untitled Lesson', project, false, false, false);
            if (showSuccessMessage) {
                this.showSuccessMessage(project, showSuccessMessage);
            }

        } catch (err) {
            console.log(err);
            appStore.createAlertFromMessageId('error', 'notifications.saveError');
        } finally {
            runInAction(() => {
                this.isProcessing = false;
                mainStore.toggleProgressLoader(false);
            });
        }
    };

    showSuccessMessage = (project, showSuccessMessage = true) => {
        const isNewProject = !project.id || !this.enrichedProjects.find(item => item.id === project.id);
        const isStudentProject = project.type === ProjectType.Project;
        let successMessage = isStudentProject ? 'successProjectUpdate' : 'successAssignmentUpdate';
        if (isNewProject) {
            if (isMobile()) return;
            if (looperStore.isOtherUserLesson) {
                successMessage = 'successStudentAssignmentSave';
                if (!showSuccessMessage) {
                    return;
                }
            } else if (project.groupId) {
                successMessage = 'successGroupAssignmentSave';
            } else {
                successMessage = isStudentProject ? 'successProjectSave' : 'successLessonSave';
            }
        } else {
            if ((isTeacher() && !(looperStore.isOtherUserLesson || project.groupId)) || isAdmin()) {
                successMessage = 'successLessonUpdate';
            }
        }
        appStore.createAlertFromMessageId('success', `notifications.${successMessage}`);
    };

    @action startCanvas = (type, useMobileZoom) => {
        const imgUrl = canvasTemplateUrl(type);
        const fileName = type ? `${capitalizeFirstLetter(type)} ` : 'Canvas ';
        let scale = 1;
        if (isMobile() && useMobileZoom) {
            scale = 2;
        } else if (isDesktop() && window.innerHeight < MAX_HEIGHT_FOR_CANVAS_ZOOM) {
            scale = 1.5;
        }
        const fileObj = {
            id: guid(),
            name: this.generateFileName(this.files, fileName),
            canvas: [{
                id: guid(),
                s3TeacherKey: null,
                s3StudentKey: null,
                type,
                page: 1,
                numPages: 1,
                useMobileZoom: useMobileZoom,
                scale: scale
            }],
            url: imgUrl,
            page: 1,
            numPages: 1,
            type: 'image/png',
            userId: getId(),
        };
        this.files.push(fileObj);
        setTimeout(() => {
            runInAction(() => {
                this.isCanvasEditable = true;
            });
        })
        looperStore.setProjectAttachments(this.files.slice());
        if (isStudent()) {
            this.addNotificationToLesson(LessonNotificationType.WhiteboardAddedToLesson);
        }
    };

    addNotificationToLesson = (lessonNotificationType) => {
        this.notificationsToLesson.push(lessonNotificationType);
    }


    @action editCanvas = (val) => {
        this.isCanvasEditable = val;
    };

    @action setAutoStartCanvas = (val) => {
        this.autoStartCanvas = val;
    };

    @action editNotationCanvas = (val) => {
        this.isNotationCanvasEditable = val;
    };

    @action saveFile = async (file, onProgressChange, callback) => {
        const attachmentId = guid();
        const key = `attachments/${attachmentId}`;
        const fileObj = {
            name: file.name || this.generateFileName(this.files, 'Image '),
            type: file.type,
            url: '/' + key,
            id: key,
            isTemp: true,
            page: 1,
            numPages: 1,
            userId: file.userId,
            canvas: [this.prepareNewCanvas(attachmentId)],
        };
        const uploadImageInstance = {};
        this.files.push(fileObj);
        const promise = uploadToS3(file, key, file.type, (onProgressChange ? onProgressChange : uploadsProgressStore.onUploadProgress), ATTACHMENT_BUCKET, true, uploadImageInstance);
        if (!onProgressChange) {
            uploadsProgressStore.addUpload(key, file.name, uploadImageInstance.manage);
        }
        try {
            if (callback) callback();
            await promise;
            const uploadedImage = this.files.find(f => f.url === key);
            if (uploadedImage) {
                runInAction(() => {
                    uploadedImage.isTemp = false;
                });
            }
            looperStore.setProjectAttachments(this.files);
            if (!onProgressChange) {
                uploadsProgressStore.finishUpload(key);
            }
        } catch (err) {
            runInAction(() => {
                this.files = this.files.filter(f => f.id !== key);
                if (callback) callback();
            });
        } finally {
            runInAction(() => {
                this.isFileLoading = false;
            });
        }
    };

    @action onFileChange = (target, onProgressChange, callback) => {
        const files = Array.isArray(target) ? target : [target];
        return Promise.all(files.map(async (file) => {
            if (attachedTypeFile(file)) {
                this.isFileLoading = true;
                await this.saveFile(file, onProgressChange, callback);
            } else {
                appStore.createAlertFromMessageId('warning', 'notifications.unsupportedFormats');
                this.isFileLoading = true;
                await this.saveFile(file, onProgressChange, callback);
            }
        }));
    };

    @action onFileDelete = (fileIndex) => {
        this.files.splice(fileIndex, 1);
        looperStore.setProjectAttachments(this.files);
    };

    @action renameFile = (newName, index) => {
        this.files[index].name = newName;
        looperStore.setProjectAttachments(this.files);
    };

    @action rotateImageFile = (id) => {
        this.files = this.files.map(n => (n.id === id ? {...n, rotate: this.rotateFile(n.rotate)} : n));
        looperStore.setProjectAttachments(this.files);
    };

    @action initVideos = (videos) => {
        this.videos = videos.filter(video => video);
        this.videosLinks = this.getVideoUrls(this.videos);
    };

    rotateFile = (ang = 0) => {
        switch (ang) {
            case 0:
                return 90;
            case 90:
                return 180;
            case 180:
                return 270;
            default:
                return 0;
        }
    };

    getVideoUrls = videos => (
        videos.map(({src, name, userId, isTemp}) => {
            if (/^https?:\/\//.test(src)) {
                return {
                    id: src,
                    fromS3: false,
                    name: name || 'Untitled Video',
                    src
                };
            }
            let key = src;
            if (src.indexOf('videos/') < 0) {
                key = 'videos/' + src;
            }
            const newKey = key.replace('videos/', 'videos-converted/')
            return {
                id: key,
                fromS3: true,
                name: name || 'Uploaded Video',
                src: [`/${newKey}.mp4`, `/${key}`],
                poster: `/${newKey}.0000001.jpg`,
                userId,
                isTemp
            };
        })
    );

    generateFileName = (files = [], prefix = 'File ') => {
        const fileNumbers = files.map(f => {
            const match = f.name.match(/\s\d+$/);
            return match ? parseInt(match[0], 10) : 0;
        });
        const maxNumber = Math.max(0, ...fileNumbers);
        const fileName = (maxNumber < 10 ? '0' : '') + (maxNumber + 1);
        return `${prefix}${fileName}`;
    };

    uploadVideoToS3 = async (file, onProgressChange, callback) => {
        const id = guid();
        const key = `videos/${id}`;
        const videoObj = {
            src: key,
            name: checkFileExtension(file.name) ? file.name : this.generateFileName(this.videos, 'Video '),
            isTemp: true,
            userId: getId()
        };
        const uploadVideoInstance = {};
        this.saveVideo(videoObj);
        const promise = uploadToS3(file, key, file.type, (onProgressChange ? onProgressChange : uploadsProgressStore.onUploadProgress), RESTRICTED_BUCKET, true, uploadVideoInstance);
        if (!onProgressChange) {
            uploadsProgressStore.addUpload(key, file.name, uploadVideoInstance.manage, true);
        }
        try {
            if (callback) callback();
            await promise;
            const uploadedVideo = this.videos.find(v => v.src === id);
            if (uploadedVideo) {
                runInAction(() => {
                    uploadedVideo.isTemp = false;
                    this.initVideos(this.videos);
                });
            }
            if (!onProgressChange) {
                uploadsProgressStore.finishUpload(key);
            }
        } catch (err) {
            runInAction(() => {
                if (err?.code === 'RequestAbortedError') {
                    appStore.createAlertFromMessageId('success', 'network.upload.cancel', {}, 3000);
                } else {
                    appStore.createAlertFromMessageId('error', 'network.upload.error', {}, 7000);
                }
                this.videos = this.videos.filter(v => v.src !== key);
                this.videosLinks = this.videosLinks.filter(v => v.id !== key);
                if (callback) callback();
            });
        }
    };

    @action saveVideoById = (id, filename) => {
        this.saveVideo({
            src: `videos/${id}`,
            name: filename || this.generateFileName(this.videos, 'Video '),
            isTemp: false,
            userId: getId()
        });
    };

    @action saveVideo = (videoObj = {}) => {
        this.videos = [...this.videos, videoObj];
        this.videosLinks = [...this.videosLinks, ...this.getVideoUrls([videoObj])];
        looperStore.setProjectVideos(this.videos);
        looperStore.setIsEditedProject(true);
        this.addNotificationToLesson(LessonNotificationType.VideoAddedToLesson);
    };

    @action removeVideo = (index) => {
        if (index === -1) return;
        this.videos.splice(index, 1);
        this.videosLinks.splice(index, 1);
        looperStore.setProjectVideos(this.videos);
        looperStore.setIsEditedProject(true);
    };

    @action renameVideo = (newName, index) => {
        this.videos[index].name = newName;
        this.videosLinks[index].name = newName;
        looperStore.setProjectVideos(this.videos);
        looperStore.setIsEditedProject(true);
    };

    @action clearFileInput = () => {
        this.files = [];
        this.notations = [];
    };

    prepareNewCanvas = (id) => {
        return {
            id: id,
            s3TeacherKey: null,
            s3StudentKey: null,
            type: null,
            page: 1,
            numPages: 1,
            useMobileZoom: false,
            scale: 1
        }
    }

    fileHasAnnotations = (file) => {
        if (file && file.canvas && file.canvas.length > 0) {
            return file.canvas.some(canvas => canvas?.s3TeacherKey || canvas?.s3StudentKey);
        }
    }

    processFile = (file) => {
        file.page = file.page || 1;
        file.numPages = file.numPages || 1;
        file.rotate = file.rotate || 0;
        if (file.canvas && !file.canvas.length) {
            file.canvas = [file.canvas];
        } else if (!file.canvas) {
            file.canvas = [this.prepareNewCanvas(file.id)]
        }
        for (let i = 0; i < (file.numPages || file.canvas.length || 1); i++) {
            if (file.canvas[i]) {
                file.canvas[i].scale = file.canvas[i].scale || 1;
            } else {
                file.canvas[i] = this.prepareNewCanvas(file.id);
            }
        }
        file.url = file.url?.startsWith('attachments/') ? `/${file.url}` : file.url
        file.id = file.id || file.url;
        return file;
    }


    processFiles = (files) => {
        return files.map(file => {
            return this.processFile(file)
        }).slice();
    }

    @action setFileInput = (project, sort) => {
        this.clearFileInput();
        if (project.attachments) {
            this.files = this.processFiles(project.attachments)
        }
        if (project.notations) {
            this.notations = this.processFiles(project.notations);
            if (sort) {
                this.notations = this.notations.sort(item => {
                    return item.default || this.isRelevantXml(item) ? -1 : 1;
                });
            }
        }
    };

    openFilePreview = (file, dialog = true) => action(() => {
        this.openedVideo = '';
        this.openedFile = {
            ...file,
            type: attachedTypeFile(file)
        };
        if (dialog) {
            dialogStore.openFilePreviewDialog();
        }
    });

    openVideoPreview = video => action(() => {
        this.openedFile = {};
        this.openedVideo = video;
    });

    @action closeVideoPreview = () => {
        this.openedVideo = null;
    };

    @action editLesson = (lesson) => {
        this.isLessonEditing = true;
        this.editedLesson = lesson;
    };
    @action finishEditLesson = () => {
        this.isLessonEditing = false;
        this.videos = [];
    };

    @action
    updateLessonState = (state, updatePlatformState = true) => {
        this.lessonState = state;
        if (state === LessonState.Create) {
            this.clearFileInput();
            this.initVideos([]);
        }
        if (updatePlatformState) {
            mainStore.updatePlatformMode(state === LessonState.Create ? PlatformMode.Create : PlatformMode.Edit);
        }
    };

    @action openLessonBackgroundEditing = (lesson) => {
        this.isLessonBackgroundEditing = true;
        this.editedLesson = lesson;
    };

    @action closeLessonBackgroundEditing = () => {
        this.isLessonBackgroundEditing = false;
    };

    @action updatedLessonBackground = async (file, lesson) => {
        this.editedLesson = lesson;
        await this.saveLessonBackground(file, true);
        runInAction(() => {
            this.editedLesson = null;
        });
    };

    @action resetLessonBackground = async () => {
        mainStore.toggleProgressLoader(true);
        try {
            await request(`${PROJECT}/${this.editedLesson.id}`, {method: 'POST', body: {backgroundImg: LessonDefaultImage}});
            runInAction(() => {
                this.editedLesson.backgroundImg = LessonDefaultImage;
            });
        } catch (err) {
            console.warn(err.message);
            // appStore.createAlertFromMessageId('error', 'notifications.saveError');
        } finally {
            runInAction(() => {
                mainStore.toggleProgressLoader(false);
            });
        }
    };

    @action saveLessonBackground = async (file, isEdit) => {
        if (!isEdit) {
            this.closeLessonBackgroundEditing();
            return;
        }
        this.isSavingBackground = true;
        const id = `${getId()}_${Date.now()}`;
        try {
            const lesson = await this.fetchProject(this.editedLesson.id);
            await uploadToS3(file, id, file.type, null, 'musico-public-bucket/media/lesson', false);
            runInAction(() => {
                lesson.backgroundImg = `/media/lesson/${id}`;
                this.editedLesson.backgroundImg = `/media/lesson/${id}`;
            });
            await this.saveProject(lesson.name, lesson, false);
            this.closeLessonBackgroundEditing();
        } catch (err) {
            appStore.createAlertFromMessageId('error', 'notifications.saveError');
        } finally {
            runInAction(() => {
                this.isSavingBackground = false;
            });
        }
    };

    @action prepareNewLesson = async (newLessonParams) => {
        looperStore.clearLooper();
        // dialogStore.openSetProjectNameDialog();
        const editedLesson = {...looperStore.loopedProject, ...newLessonParams};
        this.isSaveProcessing = true;
        if (!isStudent()) {
            editedLesson.type = isTeacher() || isSchoolAdmin() ? ProjectType.Lesson : ProjectType.Global;
        }
        !isTeacher() && customEvent(events.CustomEvent, {category: category.CreateProject})
        try {
            await looperStore.addProjectToLooper({...editedLesson, name: 'New Lesson'}); // todo
            wizardStore.setStudioMode(StudioMode.Welcome);
            // if (isAdmin()) {
            //     this.handleProjectSave();
            // }
            // closeLessonNameDialog();
            this.setIsNewLessonFromLooper(false);
            go('/create', {}, true)
            this.updateLessonState(LessonState.Update);

        } catch (err) {
            console.log('error preparing new lesson', err);
            appStore.createAlertFromMessageId('error', 'drag.action.error');
        } finally {
            runInAction(() => {
                this.isSaveProcessing = false;
            });
        }

    };

    @action editProjectName = (name, value = '') => {
        this.editedLesson.name = value;
    };

    @action setProjectDoneState = async (lesson) => {
        if (!lesson.id) {
            return;
        }
        const doneState = !!lesson.markedAsDone;
        this.editedLesson = lesson;
        this.isLessonEditing = true;

        try {
            lesson.markedAsDone = !doneState;
            this.editedLesson.markedAsDone = !doneState;
            await request(`${PROJECT}/${lesson.id}`, {method: 'POST', body: {markedAsDone: !doneState}});
        } catch (err) {
            console.log(err);
        } finally {
            runInAction(() => {
                this.editedLesson = null;
                this.isLessonEditing = false;
            });
        }
    };

    @action openSelectLessonPlanFromLibraryDialog = (params = {}) => {
        looperStore.clearLooper();
        dialogStore.openSetProjectNameDialog();
        this.editedLesson = {...looperStore.loopedProject, ...params};
    };


    @action removeFromTimeline = (projectId) => {
        const projectIndex = this.projectArray.findIndex(p => p.id === projectId);
        if (projectIndex >= 0) {
            this.projectArray.splice(projectIndex, 1);
        }
    }

    /**
     * Perform the project delete or leave (if owner delete otherwise leave) functionality
     * @param project   {Object}    The project to delete or leave
     * @param studentId {String}    The student is
     * @returns {Promise.<void>}
     */
    @action
    deleteProject = async (project, studentId) => {
        if (!project) {
            return;
        }
        try {
            mainStore.toggleProgressLoader(true);
            await request(`${USER_PROJECT}/${project.id}${studentId ? `/${studentId}` : ''}`, {method: 'DELETE'});
            runInAction(async () => {
                if (studentId) {
                    this.activities.forEach(module => {
                        const lessonIndex = module.lessons.findIndex(p => p.id === project.id);
                        if (lessonIndex > -1) {
                            module.lessons.splice(lessonIndex, 1);
                        }
                    });
                    if (project.parentProjectId) {
                        await this.fetchProject(project.parentProjectId, true, true);
                    }
                } else {
                    const projectIndex = this.projectArray.findIndex(p => p.id === project.id);
                    this.projectArray.splice(projectIndex, 1);
                    this.groupedStudentProjects = this.groupedStudentProjects.filter(p => p.id !== project.id);
                }
            });
            appStore.createAlertFromMessageId(AlertType.success, 'lessonLibrary.lesson.deleted');

        } catch (err) {
            throw err;
        } finally {
            mainStore.toggleProgressLoader(false);
        }
    };

    /**
     * Perform the project delete or leave (if owner delete otherwise leave) functionality
     * @param project   {Object}    The project to delete or leave
     * @param studentId {String}    The student is
     * @returns {Promise.<void>}
     */
    @action
    deleteProjectByFolder = async (folderId) => {
        if (!folderId) {
            return;
        }
        try {
            let projectToDelete = this.folderProjects(folderId);
            await request(`${PROJECT}`, {method: 'DELETE', body: projectToDelete.map(p => p.id)});
            runInAction(() => {
                projectToDelete.map(project => {
                    const projectIndex = this.projectArray.findIndex(p => p.id === project.id);
                    this.projectArray.splice(projectIndex, 1);
                })
            });
        } catch (err) {
            throw err;
        }
    };

    @action
    clearActiveProject = () => {
        this.handleAccumulatedPlayTimeStatusChanged();
        this.activeProjectID = null;
        this.isActiveProjectPlaying = false;
        this.clearFileInput();
        this.initVideos([]);
        looperStore.clearLooper();
        actionStore.init();
    };

    @action
    onStudentsAssigned = (lessonId, students, isPublic) => {
        const lesson = this.projectArray.find(s => s.id === lessonId);
        if (lesson) {
            lesson.assignedToAll = isPublic;
            lesson.assignedUsers = students;
            this.selectedLessonInLibrary.assignedToAll = isPublic;
            this.selectedLessonInLibrary.assignedUsers = students;
        }
        // this.fetchLessonActivities('', lessonId);
    };

    getProject(id) {
        return this.enrichedProjects.find(p => p.id === id);
    }

    getProjectByParentId(id) {
        return this.enrichedProjects.find(p => p.parentProjectId === id);
    }

    async onStudentEnrollment(projectId, student, studentProjectId) {
        const studentActivity = await this.fetchProject(studentProjectId, true, true);
        if (studentActivity.groupId) {
            studentActivity.groupName = groupStore.getGroupNameById(studentActivity.groupId);
        }
        let activityIndex = this.lessonActivities.findIndex(proj => proj.parentProjectId === projectId && proj.owner.id === student.id);
        if (activityIndex >= 0) {
            runInAction(() => {
                this.lessonActivities[activityIndex] = studentActivity;
            })
        }
        this.updateActivities(projectId, student.id, studentActivity);
        this.setLessonStudentProp(projectId, student.id, 'projectId', studentProjectId);
    }

    @action updateActivities(projectId, studentId, newLesson) {
        this.activities = this.activities.map(module => {
            module.lessons = module.lessons.map(proj => {
                if (proj.parentProjectId === projectId && proj.owner.id === studentId) {
                    return newLesson;
                }
                return proj;
            })
            return module;
        });
    }

    @action
    setLessonStudentProp(projectId, studentId, key, value) {
        const lesson = this.groupedStudentProjects.find(proj => proj.id === projectId);
        if (lesson) {
            const studentIndex = lesson.students.findIndex(stud => stud.id === studentId);
            if (studentIndex !== -1) {
                const student = Object.assign({}, lesson.students[studentIndex]);
                student[key] = value;
                lesson.students[studentIndex] = student;
            }
        }
    }

    @action loadMoreItems = (max) => {
        if (this.pageCount * NUM_ITEMS_PER_PAGE < max) {
            this.isFetchingAllProjects = true;
            this.isLessonPlansLoading = true;
            setTimeout(action(() => {
                this.isFetchingAllProjects = false;
                this.isLessonPlansLoading = false;
                this.pageCount += 1;
            }), 300);
        }
    };

    @action resetPagination = () => {
        this.pageCount = 1;
    };

    @action cloneLesson = async (newLesson, isOpen) => {
        await this.saveProject(newLesson.name, newLesson, false, true, false);
        if (!isOpen) {
            dialogStore.openDialog(DialogTypes.CloneProjectSuccess);
        }
    };

    @action togglePlayActiveProject = async () => {
        if (this.activeProject) {
            if (!this.activeProject.playerID) {
                await this.subscribe(this.activeProject, false, false, true);
            }
            const nextPlayStatus = this.isActiveProjectPlaying ? TrackPlayStatus.Stopped : TrackPlayStatus.Playing;
            this.handleAccumulatedPlayTimeStatusChanged();
            runInAction(() => {
                this.togglePlayPause(this.activeProject, nextPlayStatus, null, null, true);
                this.isActiveProjectPlaying = !this.isActiveProjectPlaying;
            });
        }
    };

    @action togglePlayGlobalProject = (project) => {
        this.stopAllGlobalProjects(project.id);
        this.togglesSubscribePlayPause(project, null, project.startTime, project.endTime, false, true);
    };

    stopAllGlobalProjects(excludedProjectId) {
        this.filteredLessonPlans
            .filter(curProj => curProj.playStatus === TrackPlayStatus.Playing && curProj.id !== excludedProjectId)
            .forEach(curProj => {
                this.togglePlayPause(curProj, TrackPlayStatus.Stopped);
                // console.log(curProj.name)
            });
    }

    handleAccumulatedPlayTimeStatusChanged = () => {
        if (!this.activeProject || !this.activeProject.type === ProjectType.Global) {
            return;
        }
        if (this.isActiveProjectPlaying) {
            const secondsPlayed = Math.round((Date.now() - this.lastPlayTime) / 1000);
            if (secondsPlayed >= MIN_DISCOVERY_LESSON_ACCUMULATED_PLAYING_TIME) {
                request(`${PROJECT}/${this.activeProject.id}/usage`, {method: 'POST', body: {durationInSecs: secondsPlayed}});
            }
        } else {
            this.lastPlayTime = Date.now();
        }
    }
    @action changeAdminLessonFilterState = ({value}) => {
        this.adminLessonFilterState = value;
    };

    getProjectTimeSignature = (project) => {
        let result = '4/4';
        project.actions && project.actions.forEach((action) => {
            if (action.type === TrackActionType.ChangeTSMeter) {
                result = action.target[2];
            }
        });
        return result;
    };

    @action createNewStudentLessonFromExisting = async (projectId, newLessonParams, analyticsParams, isSave = false, replaceUrl = false, guide = false) => {
        try {
            let module = null;
            try {
                if (newLessonParams.groupId) {
                    module = this.activities.find(module => module.lessons.some(lesson => lesson.parentProjectId === newLessonParams.parentProjectId));
                }
            } catch (err) {
                console.log('failed getting module:', err);
            }
            if (looperStore.isProjectLoadingToLooper) {
                console.log('Refusing to create another lesson since isProjectLoadingToLooper is true');
                return;
            }
            looperStore.setIsProjectLoadingToLooper(true);
            this.updateLessonState(LessonState.Create);
            customEvent(events.CustomEvent, {
                ...analyticsParams
            });
            if (replaceUrl) {
                goReplace('/create');
            } else {
                go('/create', {guide: guide}, true);
            }
            const project = await this.fetchProject(projectId, true);
            const newLesson = {
                ...project,
                parentProjectId: project.id,
                id: undefined,
                type: ProjectType.Lesson,
                schoolShare: false,
                disableChat: true,
                moduleId: module?.id,
                ...newLessonParams
            };
            if (project.id === newLesson.rootProjectId) { //Original Musico lesson
                delete newLesson.parentProjectId;
                delete newLesson.folderId;
                newLesson.musicoLesson = true;
            }
            delete newLesson.version;
            delete newLesson.practiceTime;
            if (isSave) {
                const response = await this.saveProject(newLesson.name, newLesson, true);
                await runInAction(async () => {
                    const parentProjectIndex = this.projectArray.findIndex(proj => proj.id === projectId);
                    this.projectArray.splice(parentProjectIndex, 1);
                    if (module) {
                        let lessons = module.lessons;
                        let lessonIndex = lessons.findIndex(lesson => lesson.parentProjectId === newLessonParams.parentProjectId);
                        lessons[lessonIndex] = response;
                        // this.updateActivity(module.id, student.id,)
                        // await this.saveModule(module.id, getId(), {...module, lessons: lessons.map(lesson => lesson.id)})
                    }
                });
                return response.id;
            } else {
                await looperStore.addProjectToLooper(newLesson, true);
                mainStore.setStudioDrawerState(StudioDrawerState.Info);
            }
        } catch (err) {
            console.log('error creating lesson', err);
            looperStore.setIsProjectLoadingToLooper(false);
            go('/');
        }
    };

    @action addLessonToLessonPlanLibrary = async (lesson, withConfirmation = true) => {
        mainStore.toggleProgressLoader(true);
        const newLesson = await request(`${PROJECT}/${lesson.id}/clone/parent`, {method: 'POST', body: {}});
        runInAction(() => {
            mainStore.toggleProgressLoader(false);
            if (isTeacher()) {
                delete newLesson.groupId;
                newLesson.parentOwnerId = newLesson.userId;
            }
            this.projectArray.unshift(newLesson);
            lesson.hasParent = true;
            if (withConfirmation) {
                dialogStore.openDialog(DialogTypes.CloneProjectSuccess);
            } else {
                appStore.createAlertFromMessageId(
                    'success', 'lessonLibrary.lesson.saved', {name: newLesson.name}, 5000);
            }
        });
    };

    @action addLessonToLessonPlansNew = async (lesson, folderId = null, sharedFolderId = null, showToast = true) => {
        try {
            mainStore.toggleProgressLoader(true);
            if (lesson.id) {
                lesson = await this.fetchProject(lesson.id, true, true);
            }
            const newLesson = {
                ...lesson,
                rootProjectId: lesson.id,
                id: undefined,
                type: ProjectType.Lesson,
                schoolShare: !!sharedFolderId,
                disableChat: true,
                folderId: folderId,
                sharedFolderId: sharedFolderId,
                ...getNewLessonParams()
            };
            delete newLesson.version;
            delete newLesson.practiceTime;
            let project = await this.saveProject(newLesson.name, newLesson, false, true, false, false);
            if (showToast) {
                appStore.createAlertFromMessageId('success', 'lessonLibrary.lesson.saved', {name: newLesson.name});
            }
            return project;
        } catch (err) {
            throw err
        } finally {
            mainStore.toggleProgressLoader(false);
        }
    }

    @action openStudentLesson = async (studentLessonParams, student) => {
        const module = this.activities.find(module => module.lessons.some(lesson => lesson.parentProjectId === studentLessonParams.parentProjectId));
        this.updateLessonState(LessonState.Update);
        const label = {name: studentLessonParams.name, id: studentLessonParams.id};
        if (student) {
            label.isDemo = student.status === StudentStatus.Demo;
        }
        if (studentLessonParams.id) {
            go(`/create/${studentLessonParams.id}`, {}, true);
        } else {
            looperStore.setIsProjectLoadingToLooper(true);
            go('/create', {}, true);
            const teacherLessonPlan = await this.fetchProject(studentLessonParams.parentProjectId);

            const newLesson = {
                ...teacherLessonPlan,
                parentProjectId: teacherLessonPlan.id,
                parentOwnerId: teacherLessonPlan.userId,
                owner: studentLessonParams.owner,
                userId: studentLessonParams.owner.id,
                moduleId: module?.id
            };
            delete newLesson.id;
            await this.saveProject(newLesson.name, newLesson, true);
            // if (module) {
            //     await runInAction(async () => {
            //         let lessons = module.lessons;
            //         let lessonIndex = lessons.findIndex(lesson => lesson.parentProjectId = studentLessonParams.parentProjectId);
            //         lessons[lessonIndex] = newProject;
            //         this.updateActivity(module.id, student.id, )
            // await this.saveModule(module.id, student.id, {...module, lessons: lessons.map(lesson => lesson.id)})
            // })
            // }
        }
    };

    createLessonFromPlan = () => {
        const {version, id, parentOwnerId, ...proj} = this.activeProject;
        const newLesson = {
            ...proj,
            type: isStudent() ? ProjectType.Project : ProjectType.Lesson, ...getOwnerDetails(),
            userId: getId(),
            rootProjectId: id,
            disableChat: true
        };
        delete newLesson.parentProjectId
        customEvent(events.CustomEvent, {category: category.Lesson, action: actions.CreateFromPlanOpen, label: newLesson.name});
        this.updateLessonState(LessonState.Create);
        setTimeout(async () => {
            await looperStore.addProjectToLooper(newLesson, true);
            mainStore.setStudioDrawerState(StudioDrawerState.Info);
        }, 0);
        looperStore.setIsProjectLoadingToLooper(true);
        go('/create', {}, true);
    };

    @action resetActivities = () => {
        this.activities = [];
        this.selectedLessonInLibrary = {};
    };

    @computed
    get getRandomDiscoveryLessonPlans() {
        return createTransformer((num) => {
            const res = [];
            const copy = [...this.lessonPlans];
            if (copy.length <= num) return copy;
            for (let i = 0; i < num; i += 1) {
                const random = Math.floor(Math.random() * (copy.length));
                res.push(copy.splice(random, 1)[0]);
            }
            return res;
        });
    }

    @action
    removeStudentFromAssignedList = async (projectId, studentId) => {
        try {
            mainStore.toggleProgressLoader(true);
            await request(`${PROJECT}/${projectId}/assign/${studentId}`, {method: 'DELETE'});
            runInAction(async () => {
                this.activities.forEach(module => {
                    const lessonIndex = module.lessons.findIndex(act => act.parentProjectId === projectId && act.owner.id === studentId);
                    if (lessonIndex > -1) {
                        module.lessons.splice(lessonIndex, 1);
                    }
                });
                await this.fetchProject(projectId, true);
            });
        } catch (err) {
            throw err;
        } finally {
            mainStore.toggleProgressLoader(false);
        }
    };

    removeStudentLesson = async (lesson, student) => {
        if (lesson.id) {
            return this.deleteProject(lesson, student);
        }
        return this.removeStudentFromAssignedList(lesson.parentProjectId, student);
    };

    isGlobalProject = type => {
        return (mainStore.isHomeMode && type === ProjectType.Global && !isAdmin());
    }

    isPreviewProject = type => {
        return ((isStudent() && type === ProjectType.Lesson) || this.isGlobalProject(type) || isGuest());
    }


    @action toggleShareLessonToSchoolLibrary = async (lessonId) => {
        try {
            mainStore.toggleProgressLoader(true);
            let lesson = await this.fetchProject(lessonId, true);
            lesson = {
                ...lesson,
                schoolShare: !lesson.schoolShare,
                sharedFolderId: !lesson.schoolShare ? lesson.sharedFolderId : null
            };
            if (lesson.schoolShare) {
                customEvent(events.CustomEvent, {
                    category: category.ShareLessonToSchoolLibrary
                });
            }
            await this.saveProject(lesson.name, lesson, false, true, true, false);
            appStore.createAlertFromMessageId(
                'success', lesson.schoolShare ? 'lessonsLibrary.card.shared' : 'lessonsLibrary.card.unshared',
                {name: lesson.name});
        } catch (err) {
        } finally {
            mainStore.toggleProgressLoader(false);
        }
    };

    updatePracticeTime = (projectId, durationInSeconds) => {
        try {
            request(`${PROJECT}/${projectId}/practice`, {method: 'POST', body: {date: Date.now(), durationInSeconds: durationInSeconds}}, true);
            runInAction(() => {
                this.activities.map(module => {
                    const lessonIndex = module.lessons?.findIndex(lesson => lesson.id === projectId);
                    if (lessonIndex >= 0) {
                        module.lessons[lessonIndex].practiceTime = module.lessons[lessonIndex].practiceTime || [];
                        let practiceTime = module.lessons[lessonIndex].practiceTime;
                        if (practiceTime && practiceTime.length > 0) {
                            practiceTime[practiceTime.length - 1].durationInSeconds += durationInSeconds;
                        } else {
                            practiceTime.push({durationInSeconds});
                        }
                    }
                })
                looperStore.incrementProjectPracticeTime(durationInSeconds);
            })
        } catch (err) {
            console.log(err);
        }
    }

    sortListByName = (list) => {
        return list.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
    }

    sortListByCategory = (list) => {
        return list.sort((a, b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0));
    }

    sortListByCreatedDate = (list) => {
        return list.sort((a, b) => Date.parse(b.created) - Date.parse(a.created));
    }

    sortListByUpdatedDate = (list) => {
        return list.sort((a, b) => Date.parse(b.updated) - Date.parse(a.updated));
    }

    sortListByTrending = (list) => {
        return list.sort((a, b) => b.numTimesUsed - a.numTimesUsed);
    }

    sortListByRecommended = (list) => {
        return list.sort((a, b) => {
            const aVal = a.instruments && (a.instruments.includes(getUserMainInstrument()) || a.instruments.map((i) => i.name).includes(getUserMainInstrument())) ? 1 : 0;
            const bVal = b.instruments && (b.instruments.includes(getUserMainInstrument()) || b.instruments.map((i) => i.name).includes(getUserMainInstrument())) ? 1 : 0;
            if (aVal && bVal) {
                return Date.parse(b.updated) - Date.parse(a.updated);
            }
            return bVal - aVal;
        });
    }

    sortListByPublicFirst = (list) => {
        return list.sort((a, b) => {
            let aVal = (a.isPublishTeachers ? 1 : 0) + (a.isPublishStudents ? 1 : 0);
            let bVal = (b.isPublishTeachers ? 1 : 0) + (b.isPublishStudents ? 1 : 0);
            if (aVal === 1 && bVal === 1) {
                return b.isPublishTeachers && a.isPublishStudents ? 1 : a.isPublishTeachers && b.isPublishStudents ? -1 : 0
            }
            return bVal - aVal;
        });
    }

    sortListByPublicLast = (list) => {
        return this.sortListByPublicFirst(list).reverse();
    }

    getGlobalLessonsSortByList = () => {
        if (!this.sortByList || isAdmin()) { //TODO Ugly hack.. because list is requested before user is authenticated so isAdmin false first time
            this.sortByList = [
                {name: 'created', action: this.sortListByCreatedDate},
                {name: 'trending', action: this.sortListByTrending},
                {name: 'name', action: this.sortListByName},
                {name: 'category', action: this.sortListByCategory}
            ];

            if (isAdmin()) {
                this.sortByList.unshift({name: 'updated', action: this.sortListByUpdatedDate});
                this.sortByList.push({name: 'publishedFirst', action: this.sortListByPublicFirst});
                this.sortByList.push({name: 'publishedLast', action: this.sortListByPublicLast});
            }
            if (isTeacher()) {
                this.sortByList.unshift({name: 'recommended', action: this.sortListByRecommended});
            }
        }
        return this.sortByList;
    }


    @action sendLessonReminderEmail = async (studentId) => {
        mainStore.toggleProgressLoader(true);
        try {
            await request(`${PROJECT}/${this.activeProjectID}/reminder/${studentId}`, {method: 'POST', body: {}});
        } catch (error) {
            appStore.createAlertFromMessageId('error', 'notifications.error', 3500);
        } finally {
            runInAction(() => {
                mainStore.toggleProgressLoader(false);
            });
        }
    };

    @action setDefaultNotation = (notation) => {
        let notationIndex = this.notations.findIndex(n => n.id === notation.id);
        if (notationIndex) {
            this.notations[notationIndex] = notation;
            // notation.default = true;
            // this.notations.splice(notationIndex, 1);
            // this.notations.unshift(notation);
        }
        // this.notations = this.notations.map(item => ({...item, default: item.id === notation.id})).sort((a,b) => (a.default || b.default) ? 1 : -1);
        // console.log(this.notations[0].default);
        looperStore.setIsEditedProject(true);
    };

    @action saveNotationFile = async (file, onProgressChange, callback) => {
        const attachmentId = guid();
        const key = `attachments/${attachmentId}`;

        const fileObj = {
            id: key,
            name: file.name,
            type: file.fixedType || file.type,
            url: '/' + key,
            isTemp: true,
            page: 1,
            numPages: 1,
            userId: getId(),
            canvas: [this.prepareNewCanvas(attachmentId)],
        };

        if (attachedTypeFile(file) === AttachmentType.Pdf) {
            fileObj.rotate = 0;
        }

        this.notations.push(fileObj);

        const uploadNotationInstance = {};
        const promise = uploadToS3(file, key, 'application/octet-stream', (onProgressChange ? onProgressChange : uploadsProgressStore.onUploadProgress), ATTACHMENT_BUCKET, true, uploadNotationInstance);

        if (!onProgressChange) {
            uploadsProgressStore.addUpload(key, file.name, uploadNotationInstance.manage);
        }
        try {
            callback();
            await promise;
            const uploadedNotation = this.notations.find(v => v.id === key);
            if (uploadedNotation) {
                runInAction(() => {
                    uploadedNotation.isTemp = false;
                    looperStore.setProjectNotations(this.notations);
                    this.isFileLoading = false;
                });
            }
            if (!onProgressChange) {
                uploadsProgressStore.finishUpload(key);
            }
        } catch (err) {
            runInAction(() => {
                this.notations = this.notations.filter(v => v.id !== key);
                if (callback) callback();
            });
        }
    };

    @action onNotationFileChange = async (target, onProgressChange, callback) => {
        const files = Array.isArray(target) ? target : [target];
        return Promise.all(files.map(file => {
            this.isFileLoading = true;
            return this.saveNotationFile(file, onProgressChange, callback);
        }));
    };

    @action onNotationFileDelete = (fileIndex) => {
        this.notations.splice(fileIndex, 1);
        looperStore.setProjectNotations(this.notations);
    };

    @action addAnnoationsToNotation = (notationId, annotations) => {
        let notation = this.notations.find(a => a.id === notationId);
        notation.annotations = annotations;
        this.notations = this.notations.slice();
        looperStore.setProjectNotations(this.notations);
    }

    @action updateLooperNotations = (userAction = true) => {
        looperStore.setProjectNotations(this.notations, userAction);
    }

    @action updateLooperAttachments = (userAction = true) => {
        looperStore.setProjectAttachments(this.files, userAction);
    }

    @action clearNotations = () => {
        this.notations = [];
        this.updateLooperNotations();
    }

    @action clearImages = () => {
        this.files = [];
        this.updateLooperAttachments();
    }

    @action clearDescription = () => {
        looperStore.setProjectDescription(null);
    }

    @action clearProjectLoopers = () => {
        looperStore.clearProjectLoopers();
    }

    @action clearVideos = () => {
        this.vidoes = [];
        looperStore.setProjectVideos([]);
    }

    @action addCanvasToNotation = async (id, blob, pageCanvas, canvasWidth, canvasHeight, page = 0, withProgress = true) => {
        const key = `attachments/${guid()}`;
        withProgress && mainStore.toggleProgressLoader(true);
        try {
            let isNotation = true;
            let file = this.notations.find(a => a.id === id);

            if (isEmpty(file)) {
                isNotation = false;
                file = this.files.find(a => a.id === id);
                if (isEmpty(file)) {
                    console.log('cannot find notation with id:', id);
                    return;
                }
                if (blob) {
                    file.url = URL.createObjectURL(blob);
                    file.blob = blob;
                    file.type = blob.type;
                }
            }

            if (!pageCanvas) {
                console.log('asked to save an empty canvas for notation id:', id);
            }
            if (!file.canvas) {
                file.canvas = [];
            }
            if (file.canvas.length - 1 < page || isEmpty(file.canvas[page])) {
                let canvas = file.canvas.slice();
                canvas[page] = {id: guid()};
                file.canvas = canvas;
            }
            delete file.annotations;
            if (!file.canvas[page].width && canvasWidth) {
                file.canvas[page].width = canvasWidth;
            }
            if (!file.canvas[page].height && canvasHeight) {
                file.canvas[page].height = canvasHeight;
            }
            file.canvas[page].lastUpdated = Date.now();

            file.userId = file.userId || getId();
            if (isTeacher() || isAdmin() || isSchoolAdmin()) {
                file.canvas[page].s3TeacherKey = `/${key}`;
            }
            if (isStudent()) {
                file.canvas[page].s3StudentKey = `/${key}`;
            }
            file.canvas[page].isEmpty = pageCanvas && !pageCanvas.objects.length;
            if (isNotation) {
                // this.editNotationCanvas(false)
                looperStore.setProjectNotations(this.notations);
            } else {
                // this.editCanvas(false);
                looperStore.setProjectAttachments(this.files);
            }
            await uploadToS3(JSON.stringify(pageCanvas), key, null, null, ATTACHMENT_BUCKET, true);
        } catch (err) {
            console.log(err);
        } finally {
            withProgress && mainStore.toggleProgressLoader(false);
        }
    };

    @action getAnnotations = (notationId) => {
        let notation = this.notations.find(a => a.id === notationId);
        return notation.annotations;
    }

    @action renameNotationFile = (newName, index) => {
        this.notations[index].name = newName;
        looperStore.setProjectNotations(this.notations);
    };

    @action rotateNotationFile = (notationId) => {
        const notation = this.notations.find(a => a.id === notationId);
        notation.rotate = this.rotateFile(notation.rotate);
        notationViewerStore.setNotationRotation(notation.rotate);
        looperStore.setProjectNotations(this.notations);
    };

    @computed
    get firstTimeVisit() {
        return this.showAssignmentIntro && !isEmpty(looperStore.loopedProject.skills);
        // let x =  showSkills || (
        //     // (looperStore.isStudentAssignment && isEmpty(looperStore.loopedProject.practiceTime))
        //     // ||
        //     (isTeacher() && !looperStore.loopedProject.id && looperStore.loopedProject.rootProjectId) // global project for signed up useds
        //     ||
        //     (isGuest() && looperStore.loopedProject.type === ProjectType.Global) // global project for guests
        // );
        // console.log(x);
    };

    @computed
    get projectSkillPoints() {
        if (isEmpty(looperStore.looperProject.skills)) return 0;
        return looperStore.looperProject.skills.reduce((result, skill) => {
            result += skill.value;
            return result;
        }, 0);
    }

    @computed
    get projectPerformances() {
        const performancesList = [...looperStore.loopedProject.videoUrls || [], ...looperStore.loopedProject.loopers || []];
        return performancesList.reduce((result, item) => {
            if (item.userId === getId()) {
                result += 1;
            }
            return result;
        }, 0);
    }

    @computed
    get projectPracticeTime() {
        return this.getPracticeTime([{lessons: [looperStore.loopedProject]}]);
    }

    @action setShowAssignmentIntro = (val) => {
        this.showAssignmentIntro = val;
    };

    @action setShowAssignmentSummary = (val) => {
        this.showAssignmentSummary = val;
    };

    folderProjects = (folderId) => {
        const filteredProjects = isAdmin() ? this.filteredAdminLessonLibrary : this.myProjects;
        const projects = filteredProjects.filter(project => project.folderId === folderId || project.sharedFolderId === folderId);

        return this.filterProjectsBySearchStr(projects, searchStore.getSearchStrFor(this.searchState));
    }

    getProjectsByFolderId = (folderId) => {
        return this.isProjectsLoaded ? this.folderProjects(folderId).slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    getProjectsByFolderIdFull = (folderId) => {
        return this.isProjectsLoaded ? this.folderProjects(folderId) : [];
    }

    @computed
    get lessonPlanListUnfolded() {
        return this.lessonPlanList.filter(lesson => !lesson.folderId && lesson.userId === getId());
    }

    @computed
    get sliceLessonPlanListUnfolded() {
        return this.isProjectsLoaded ? this.lessonPlanList.filter(lesson => !lesson.folderId && lesson.userId === getId()).slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @computed
    get sliceOwnLessonPlanList() {
        return this.isProjectsLoaded ? this.lessonPlanList.filter(lesson => lesson.userId === getId()).slice(0, this.pageCount * NUM_ITEMS_PER_PAGE) : [];
    }

    @action createNewModule = async (lesson, studentId) => {
        const activity = {
            id: guid(),
            topic: newTopic(),
            note: null,
            lessons: [lesson.id],
            order: -1
        };
        this.activities.push(activity);

        this.promiseQueue.enqueue(() => this.updateActivity(activity.id, studentId, {lessons: [lesson.id]}));
    }

    getModuleByLessonId = (lessonId) => {
        if (!lessonId) {
            return null;
        }
        return this.activities.find(module => !!module.lessons.find(lesson => {
            if (lesson.id) {
                return lesson.id === lessonId
            } else if (lesson.parentProjectId) {
                return lesson.parentProjectId === lessonId;
            }
            return false;
        }));
    }

    getModuleById = (moduleId) => {
        return this.activities.find(module => module.id === moduleId);
    }

    @action editModuleByLesson = (lessonId) => {
        let module = this.getModuleByLessonId(lessonId);
        if (module) {
            module.editMode = true;
        }
    }

    @action moveLessonToModule = async (lesson, targetModuleId) => {
        let sourceModule = this.getModuleByLessonId(lesson.id || lesson.parentProjectId);
        let targetModule = this.getModuleById(targetModuleId);
        let sourceIndex = sourceModule.lessons.findIndex(l => {
            if (lesson.id) {
                return l.id === lesson.id
            } else if (lesson.parentProjectId) {
                return l.parentProjectId === lesson.parentProjectId
            }
            return false;
        });
        if (sourceIndex >= 0) {
            sourceModule.lessons.splice(sourceIndex, 1);
        }

        targetModule.lessons = targetModule.lessons || [];
        targetModule.lessons.unshift(lesson)

        this.promiseQueue.enqueue(async () => {
            await this.saveModule(sourceModule.id, sourceModule.studentId, {
                id: sourceModule.id,
                lessons: sourceModule.lessons.map(l => l.id || l.parentProjectId),
                preventNotification: false
            });
            await this.saveModule(targetModule.id, targetModule.studentId, {
                id: targetModule.id,
                lessons: targetModule.lessons.map(l => l.id || l.parentProjectId)
            });
            if (!sourceModule.topic?.text && !sourceModule.note && sourceModule.lessons.length === 0) {
                const sourceModuleIndex = this.activities.findIndex(module => module.id === sourceModule.id)
                if (sourceModuleIndex >= 0 && !sourceModule.isTemp) {
                    console.log('empty module, deleting');
                    this.activities.splice(sourceModuleIndex, 1);
                    await request(`${MODULE}/${sourceModule.id}`, {method: 'DELETE'});
                }
            }
        })

    }

    @action moduleHideTopicNoteMode = () => {
        this.showFirstTopicNotes = false;
    }

    @action moduleEditMode = (module, editMode) => {
        const activity = this.activities.find(m => m.id === module.id);
        if (activity?.editMode !== editMode) {
            activity.editMode = editMode;
        }
    }

    moveModuleEnqueue = (moduleToMove, targetModuleId) => {
        return this.promiseQueue.enqueue(() => this.moveModule(moduleToMove, targetModuleId))
    }

    @action moveModule = async (moduleToMove, targetModuleId) => {
        try {
            const targetOrder = this.activities.find(module => module.id === targetModuleId).order;
            const sourceOrder = moduleToMove.order;
            const goingUp = sourceOrder < targetOrder;

            const min = Math.min(sourceOrder, targetOrder);
            const max = Math.max(sourceOrder, targetOrder);
            if (min === max || (!goingUp && max - min <= 1)) {
                console.log('refusing to move')
                return;
            }

            this.activities.filter(activity => activity.order <= max && (activity.order > min || goingUp && activity.order === min)).forEach(activity => {
                if (activity.order === sourceOrder) {
                    activity.order = targetOrder + (goingUp ? 0 : 1);
                } else {
                    activity.order += (goingUp ? -1 : 1);
                }
            })
            await request(`${MODULE}/${moduleToMove.id}/${moduleToMove.studentId}/move`, {method: 'POST', body: {sourceOrder, targetOrder}});
        } catch (err) {
            console.log('failed to move modules', moduleToMove, targetModuleId, err)
        }
    }

    @action addNewModule = (studentId, params) => {
        let lastActivity = maxBy(this.activities, 'order');
        this.activities.push({
            id: guid(),
            studentId: studentId,
            created: new Date().toDateString(),
            topic: newTopic(),
            note: null,
            lessons: [],
            order: (lastActivity?.order || 0) + 1,
            editMode: true,
            isTemp: true,
            ...params
        })
    }

    @action updateTopic = async (id, studentId, topic) => {
        this.promiseQueue.enqueue(() => this.updateActivity(id, studentId, {topic}));
    }

    @action updateNote = async (id, studentId, note) => {
        this.promiseQueue.enqueue(() => this.updateActivity(id, studentId, {note}));
    }

    promiseWrapper = (func) => {
        return new Promise(async (resolve, reject) => {
            try {
                resolve(await func());
            } catch (err) {
                reject(err);
            }
        })
    }

    @action saveModule = async (id, studentId, data) => {
        try {
            return await request(`${MODULE}/${id}/${studentId}`, {method: 'POST', body: {id, ...data}});
        } catch (err) {
            console.log('error saving module: ', err);
            throw err
        }
    }

    @action updateActivity = async (id, studentId, data, finalEditMode = false) => {
        console.log('start update activity', data);
        const activityIndex = this.activities.findIndex(activity => activity.id === id);
        const activity = {...this.activities[activityIndex], ...data};
        try {
            this.activities[activityIndex].topic = activity.topic;
            this.activities[activityIndex].note = activity.note;
            this.activities[activityIndex].editMode = finalEditMode || activity.editMode;
            if (!activity.topic?.text && !activity.note && activity.lessons.length === 0) {
                if (!activity.isTemp) {
                    console.log('empty module, deleting');
                    this.activities.splice(activityIndex, 1);
                    await request(`${MODULE}/${id}`, {method: 'DELETE'});
                }
            } else {
                const saved = await this.saveModule(id, studentId, {id, ...data, order: activity.order});
                runInAction(() => {
                    try {
                        // this.activities[activityIndex].order = saved.order;
                        this.activities[activityIndex].isTemp = false;
                        this.activities[activityIndex].teacherId = getId();
                    } catch (err) {
                        console.log('failed updating local copy of activitiy maybe it is already deleted', err);
                    }
                })
            }
            // console.log('end update activity');
        } catch (err) {
            console.log('error updating module', err);
            appStore.createAlertFromMessageId('error', 'assignments.module.error');
        }
    }

    @action removeActivityIfNeeded = id => {
        const activityIndex = this.activities.findIndex(activity => activity.id === id);
        const activity = this.activities[activityIndex];
        activity.editMode = false;
        if (activity && !activity.topic?.text && !activity.note && activity.isTemp) {
            this.activities.splice(activityIndex, 1);
        }
    }

    @computed
    get rootProjectIdMap() {
        return this.enrichedProjects.reduce((map, project) => {
            if (!project.rootProjectId) return map
            map[project.rootProjectId] = true
            return map
        }, {})
    }

    @action updateNumPages = (id, numPages) => {
        const pdfToProcess = this.notations.find(a => a.id === id) || this.files.find(a => a.id === a.id)
        pdfToProcess.numPages = numPages;
        this.processFile(pdfToProcess)
        this.updateLooperNotations(false);
        this.updateLooperAttachments(false);
    }
}

const projectStore = new ProjectStore();
export default projectStore;
